import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const Tournament = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Tournament</h2>
                            <p>
                                The Tournaments program at Net Nest Badminton Sports Club is designed to provide players with real match exposure, competitive experience, and the confidence required to perform under pressure. Our tournaments play a vital role in transforming practice skills into match-winning performances while promoting sportsmanship, discipline, and a winning mindset.
                            </p>
                            <h2>Purpose</h2>
                            <p>
                                Apply training techniques in real match situations
                                <br></br>
                                Build confidence and mental strength
                                <br></br>
                                Understand match strategies and scoring systems
                                <br></br>
                                Develop the ability to handle pressure and competition
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Wide Range of Tournament Categories</h2>
                            <p>
                                <b>Sub-Junior Tournaments –</b> Designed for young beginners to gain early match experience
                                <br></br>
                                <b>Junior Tournaments –</b> Focused on developing competitive confidence and consistency
                                <br></br>
                                <b>Senior Tournaments –</b> For advanced and professional players to showcase their skills
                                <br></br>
                                <b>Open Tournaments –</b> Inclusive events welcoming players from outside the club
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Singles & Doubles Formats</h2>
                            <p>
                                Men’s Singles & Women’s Singles
                                <br></br>
                                Men’s Doubles & Women’s Doubles
                                <br></br>
                                Mixed Doubles
                            </p>
                            <h2>Professional Match Environment</h2>
                            <p>
                                Standard indoor courts and quality equipment
                                <br></br>
                                Qualified referees and umpires
                                <br></br>
                                Proper scheduling and match management
                                <br></br>
                                Fair play and transparent scoring systems
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Skill Development Through Competition</h2>
                            <p>
                                Shot selection and tactical awareness
                                <br></br>
                                Match fitness and endurance
                                <br></br>
                                Decision-making under pressure
                                <br></br>
                                Emotional control and resilience
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Ranking, Recognition & Awards</h2>
                            <p>
                                Trophies, medals, and certificates
                                <br></br>
                                Player rankings and performance recognition
                                <br></br>
                                Awards for best player, rising star, and fair play
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Exposure & Growth Opportunities</h2>
                            <p>
                                Valuable exposure to different playing styles
                                <br></br>
                                Opportunities to compete beyond the club level
                                <br></br>
                                Preparation for district, state, and national tournaments
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Safe & Well-Organized Events</h2>
                            <p>
                                Proper warm-up and recovery facilities
                                <br></br>
                                First-aid and injury support
                                <br></br>
                                Smooth event coordination and time management
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Who Can Participate?</h2>
                            <p>
                                Net Nest Badminton Sports Club members
                                <br></br>
                                Amateur and professional players
                                <br></br>
                                Young talents and seasoned athletes
                                <br></br>
                                Players aiming for competitive badminton
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Tournament;
